export default {
  root: 'focus:outline-none focus:outline-offset-0 focus-visible:ring-0 ring-inset focus-visible:ring-primary-400 dark:focus-visible:ring-primary-300'
}
